export default {
  description: {
    id: 'resolution_flow_resolution_option_sync_chat_description',
    defaultMessage: 'Get help from an expert in real time.',
  },
  kicker: {
    id: 'resolution_flow_resolution_option_sync_chat_kicker',
    defaultMessage: 'ASAP',
  },
  title: {
    id: 'resolution_flow_resolution_option_sync_chat_title',
    defaultMessage: 'Chat with an agent',
  },
}
